import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "white",
    padding: "12px",
  },
  divButtons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    margin: "12px 0 12px 12px",
  },
  input: {
    padding: "8px 0px",
  },
  selectLabel: {
    marginTop: "10px",
    backgroundColor: "white",
    color: 'rgba(66,66,66,1)',
    padding: "0 6px",
  },
  divDadosBancarios: {
    marginLeft: 5,
    marginTop: 18,
    marginBottom: 10,
    fontSize: 15,
    fontWeight: 500
  },
}));
